const EMPTY_CLIENT_STATES = {
  affiliated: 0,
  contacted: 0,
  visited: 0,
  completed: 0,
};

function hasOverviewCounts(overview) {
  const total = overview?.users?.total ?? 0;
  return total > 0;
}

function buildClientStatesFromUsers(users = []) {
  const states = { ...EMPTY_CLIENT_STATES };
  users
    .filter((user) => user.is_client && user.state)
    .forEach((user) => {
      if (states[user.state] !== undefined) {
        states[user.state] += 1;
      }
    });
  return states;
}

export function buildAdminDashboardSnapshot(overview, users = []) {
  const clientUsers = users.filter((user) => user.is_client);
  const vendorUsers = users.filter((user) => user.is_vendor);
  const adminUsers = users.filter((user) => user.is_admin);

  const usersFromList = {
    total: users.length,
    admins: adminUsers.length,
    vendors: vendorUsers.length,
    clients: clientUsers.length,
  };

  const referralsFromList = {
    total: clientUsers.filter((user) => user.referred_by_username).length,
    active_referrers: new Set(
      clientUsers
        .filter((user) => (user.referrals_count || 0) > 0)
        .map((user) => user.id)
    ).size,
  };

  const clientStatesFromList = buildClientStatesFromUsers(users);

  const topVendorsFromList = vendorUsers
    .map((vendor) => ({
      id: vendor.id,
      username: vendor.username,
      clients_count: vendor.clients_count || 0,
      referrals_count: 0,
      commission: 0,
    }))
    .sort((a, b) => b.clients_count - a.clients_count);

  const topClientsFromList = clientUsers
    .filter((client) => (client.referrals_count || 0) > 0)
    .map((client) => ({
      id: client.id,
      username: client.username,
      referrals_count: client.referrals_count || 0,
      reward_points: client.reward_points || 0,
    }))
    .sort((a, b) => b.referrals_count - a.referrals_count);

  if (!overview || !hasOverviewCounts(overview)) {
    const totalReferrals = referralsFromList.total;
    return {
      users: usersFromList,
      referrals: {
        total: totalReferrals,
        active_referrers: referralsFromList.active_referrers,
        avg_per_client: clientUsers.length > 0 ? totalReferrals / clientUsers.length : 0,
      },
      revenue: {
        total: totalReferrals * 25,
        per_referral: 25,
        per_vendor: vendorUsers.length > 0 ? (totalReferrals * 25) / vendorUsers.length : 0,
      },
      client_states: clientStatesFromList,
      prospect_states: overview?.prospect_states || {},
      links: overview?.links || {
        active: 0,
        total_clicks: 0,
        total_conversions: 0,
        conversion_rate: 0,
      },
      averages: {
        referrals_per_client: clientUsers.length > 0 ? totalReferrals / clientUsers.length : 0,
        clients_per_vendor: vendorUsers.length > 0 ? clientUsers.length / vendorUsers.length : 0,
      },
      top_performers: {
        vendors: topVendorsFromList.slice(0, 5),
        clients: topClientsFromList.slice(0, 5),
      },
    };
  }

  return {
    ...overview,
    users: overview.users || usersFromList,
    referrals: overview.referrals || referralsFromList,
    client_states: overview.client_states || clientStatesFromList,
  };
}
